import { CommonModule } from '@angular/common';
import { Component, inject, Input, signal } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { TagModule } from 'primeng/tag';
import { SkeletonModule } from 'primeng/skeleton';
import { Provider } from 'src/app/demo/api/provider';
import { InsuranceProvidersService } from 'src/app/demo/service/insurance-providers.service';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { NgxTranslateModule } from 'src/app/translate.module';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/demo/service/language.service';
import { languages } from 'src/app/demo/constants/languages';
import { MessageService } from 'primeng/api';
import { showErrorToast } from 'src/app/demo/utilities/toast-utils';
import { Router, RouterModule } from '@angular/router';

@Component({
    selector: 'app-provider-card',
    standalone: true,
    imports: [
        CommonModule,
        AvatarModule,
        NgxTranslateModule,
        RouterModule,
        TagModule,
        TooltipModule,
        ButtonModule,
        SkeletonModule,
    ],
    templateUrl: './provider-card.component.html',
    styleUrl: './provider-card.component.scss',
})
export class ProviderCardComponent {
    @Input() provider!: Provider;
    logo!: any;

    router = inject(Router);
    blobUrl = signal<string>('');

    languages: any[] = languages;
    selectedLanguage!: string;

    constructor(
        private providerService: InsuranceProvidersService,
        private translateService: TranslateService,
        private translate: TranslateService,
        private messageService: MessageService,
        private languageService: LanguageService
    ) {}

    ngOnInit() {
        this.fetchLogo();
        this.initializeLocale();
    }

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    onProviderClicked() {
        console.log('Clicked');
        this.router.navigate(['/home/insurance-providers/' + this.provider.id]);
    }

    setLanguage(language: string) {
        this.translateService.use(language);
        this.languageService.setLanguage(language);
    }

    fetchLogo() {
        this.providerService.fetchProviderLogo(this.provider.id).subscribe({
            next: (value) => {

                if (
                    value['mimeType'] === 'image/png' ||
                    value['mimeType'] === 'image/jpeg' ||
                    value['mimeType'] === 'image/svg'
                ) {
                    const byteCharacters = atob(value['content']);
                    const byteNumbers = new Uint8Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const blobItem = new Blob([byteNumbers], {
                        type: value['mimeType'],
                    });
                    this.blobUrl.set(URL.createObjectURL(blobItem));
                } else {
                    console.log('Invalid mime-type');
                }
            },
            error: (err) => {
                showErrorToast(
                    this.translate.instant(err.error.messageKey),
                    this.messageService,
                    this.translate
                );
            },
        });
    }
}
